export const disableActionsByDefault = (columnId: string) => {
  return (
    columnId === 'empresa-periodo-id' ||
    columnId === 'empresa-codigo-id' ||
    columnId === 'categiria-descricao-id'
  )
}
